var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipesmenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 15,
    height: 17.94,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 15,
    height: 17.94,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.64,
    y: 4.7,
    width: 6.8,
    height: 16.24,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4876"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2130",
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4865"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4806"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9034",
    d: "M5.78,4.7l.78-1.06h13.02l.22,.88v13.68l-.49,.65-.88,.79L5.78,4.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4805"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9035",
    d: "M18.71,3H6.57l-1.57,1.7V20.94h12.14c.72,0,1.3-.58,1.3-1.3V5.99c0-.72-.58-1.3-1.3-1.3H5.78l.78-1.05h12.1c.43,0,.78,.35,.78,.78v13.96c0,.21-.09,.41-.24,.56l-.3,.28c.63-.1,1.09-.64,1.09-1.28V4.3c0-.72-.58-1.3-1.3-1.3h0",
    style: {
      fill: "#db001d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4803",
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4802"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9036",
    d: "M18.44,19.64V5.99c0-.72-.58-1.3-1.3-1.3h-5.5V20.94h5.5c.72,0,1.3-.58,1.3-1.3",
    style: {
      fill: "#0d0c0d"
    }
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9037",
    d: "M9.73,9.99c.19,0,.38,.05,.55,.14,.12-.75,.83-1.26,1.58-1.14,.58,.1,1.04,.55,1.14,1.14,.58-.31,1.3-.09,1.6,.49s.09,1.3-.49,1.6c-.17,.09-.36,.14-.56,.14v2.77h-3.82v-2.77c-.66,0-1.19-.53-1.19-1.19,0-.66,.53-1.19,1.19-1.19h0",
    style: {
      fill: "#fff"
    }
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipesmenu);
export default __webpack_public_path__ + "static/media/recipesmenu.e1ea34c72d372d0a7da65c64d26e9b85.svg";
export { ForwardRef as ReactComponent };